$(document).on('turbolinks:load', function(){

  if (location.hash) {
    $('a[href=\'' + location.hash + '\']').tab('show');
  }
  var activeTab = localStorage.getItem('activeTab');
  if (activeTab) {
    $('a[href="' + activeTab + '"]').tab('show');
  }

  $('body').on('click', 'a[data-toggle=\'tab\']', function (e) {
    e.preventDefault()
    var tab_name = this.getAttribute('href')
    if (history.pushState) {
      history.pushState(null, null, tab_name)
    }
    else {
      location.hash = tab_name
    }
    localStorage.setItem('activeTab', tab_name)

    $(this).tab('show');
    return false;
  });
  $(window).on('popstate', function () {
    var anchor = location.hash ||
      $('a[data-toggle=\'tab\']').first().attr('href');
    $('a[href=\'' + anchor + '\']').tab('show');
  });

  // for each tab link
  $('#devIndex-tabs a').each(function() {
    // does it's related div (by content id) not have a p element?
      if ($('#' + $(this).data('content-id')).has('p').length == 0) {
        // if not, find the link's parent li element and hide it
          $(this).closest('li').hide();
      }
  });
});

$(document).on('turbolinks:load', function(){
  $("#dgroup a.add_fields").
    data("association-insertion-position", 'before').
    data("association-insertion-node", 'this');

  $('#dgroup').bind('cocoon:after-insert',
     function() {
       $("#dgroup_from_list").hide();
       $("#dgroup a.add_fields").hide();
     });
  $('#dgroup').bind("cocoon:after-remove",
     function() {
       $("#dgroup_from_list").show();
       $("#dgroup a.add_fields").show();
     });
});


$(document).on('turbolinks:load', function(){
  function check_to_hide_or_show_add_link() {
    if ($('#dgroup .nested-fields:visible').length == 1) {
       $('#dgroup .links a').hide();
     } else {
       $('#dgroup .links a').show();
     }
   }

   $('#dgroup').on('cocoon:after-insert', function() {
     check_to_hide_or_show_add_link();
   });

   $('#dgroup').on('cocoon:after-remove', function() {
     check_to_hide_or_show_add_link();
   });
   check_to_hide_or_show_add_link();
});

$(document).on('turbolinks:load', function(){
  $("#dtype a.add_fields").
    data("association-insertion-position", 'before').
    data("association-insertion-node", 'this');

  $('#dtype').bind('cocoon:after-insert',
     function() {
       $("#dtype_from_list").hide();
       $("#dtype a.add_fields").hide();
     });
  $('#dtype').bind("cocoon:after-remove",
     function() {
       $("#dtype_from_list").show();
       $("#dtype a.add_fields").show();
     });
});


$(document).on('turbolinks:load', function(){
  function check_to_hide_or_show_add_link() {
    if ($('#dtype .nested-fields:visible').length == 1) {
       $('#dtype .links a').hide();
     } else {
       $('#dtype .links a').show();
     }
   }

   $('#dtype').on('cocoon:after-insert', function() {
     check_to_hide_or_show_add_link();
   });

   $('#dtype').on('cocoon:after-remove', function() {
     check_to_hide_or_show_add_link();
   });
   check_to_hide_or_show_add_link();
});
